import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as $ from 'jquery'
import { reset } from 'redux-form'
import _ from 'lodash'
import DocumentForm from '../../../components/authorised/patient/document/DocumentForm.js'
import UploadForm from '../../../components/authorised/patient/document/UploadForm.js'
import { patientDocumentsLoad, patientDocumentLoad, patientDocumentCreate, patientDocumentUpdate, patientDocumentDelete, patientDocumentEdit, patientDocumentEditCancel } from '../../../redux/actions/patient/patientDocumentActions';
import { filterChange, filterReset } from '../../../itrust_common/redux/actions/filterActions';
import Search from '../../../itrust_common/components/others/Search';
import Tags from './Tag'
import DocumentCable from './DocumentCable'
import ScanFromDeviceModal from './ScanFromDeviceModal'
import { ModalFormWrapper } from '../../../itrust_common/components/others';
import { toggleId } from '../../../itrust_common/components/HelperFunctions';
import Alert from '../../../itrust_common/components/Alert.js';
import { patientLoad, patientUpdate } from '../../../redux/actions/patient/patientActions';
import { connectDevicesLoad } from '../../../redux/actions/storeSettings/connectDevicesActions';
import TooltipComponent from '../../../itrust_common/components/others/TooltipComponent.js';


class Document extends Component {
  constructor(props) {
    super(props);
    this.handlePatientDocumentsLoad({ ...this.props.filters, include: ['document', 'tags'] })
    this.state = {
      activeTab: "find",
      activeDocument: null,
      scanning: false,
      scannerDevices: [],
      devicesLoaded: false,
      scanModalOpen: false,
      scanMode: 'single', // single | multi
      selectedDeviceId: '',
      scanSessionId: null,
      pageCount: 0,
      multiActive: false,
    }
  }

  newScanSessionId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID()
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }

  loadScannerDevices() {
    const storeId = localStorage.getItem("StoreID")
    if (!storeId) {
      Alert.warning("Please select store from top dropdown.")
      return Promise.reject(new Error('No store'))
    }

    this.setState({ devicesLoaded: false })
    return this.props.dispatch(connectDevicesLoad({
      filler: { device_type: 'scanner_device', store_id: storeId, status: 'online' }
    })).then((res) => {
      const devices = res?.value?.data?.integrated_devices || []
      const keepId = this.state.selectedDeviceId
      const stillThere = devices.some((d) => String(d.id) === String(keepId))
      this.setState({
        scannerDevices: devices,
        devicesLoaded: true,
        selectedDeviceId: stillThere ? keepId : (devices[0] ? String(devices[0].id) : '')
      })
    }).catch(() => {
      this.setState({ scannerDevices: [], devicesLoaded: true })
    })
  }

  handleOpenScanModal() {
    const storeId = localStorage.getItem("StoreID")
    if (!storeId) {
      Alert.warning("Please select store from top dropdown.")
      return
    }

    this.loadScannerDevices()
    // Same open pattern as Appointment.js (#appointmentForm-modal)
    this.setState({ scanModalOpen: true }, () => {
      $('#scanFromDevice-modal').modal({ backdrop: 'static', keyboard: false })
    })
  }

  handleCloseScanModal() {
    if (this.state.multiActive) {
      Alert.warning("Finish or Cancel the multi-page scan first.")
      return
    }
    if (this.state.scanning) {
      Alert.warning("Wait for the current scan to finish.")
      return
    }
    $('#scanFromDevice-modal').modal('hide')
    this.setState({ scanModalOpen: false })
  }

  closeScanModalNow() {
    $('#scanFromDevice-modal').modal('hide')
    this.setState({
      scanModalOpen: false,
      scanning: false,
      multiActive: false,
      scanSessionId: null,
      pageCount: 0,
    })
  }

  armScanTimeout(ms = 45000) {
    clearTimeout(this.scanTimeout)
    this.scanTimeout = setTimeout(() => {
      this.setState({ scanning: false })
      Alert.warning("Scanner did not respond in time. Check that iTRUST Connect is online.")
    }, ms)
  }

  dispatchScanCommand({ multiAction } = {}) {
    const { patientId, staffId } = this.props
    const { scanMode, selectedDeviceId, scanSessionId } = this.state
    const deviceId = selectedDeviceId

    if (!deviceId || this.state.scanning) return Promise.resolve()

    const payload = {
      id: patientId,
      scan_from_store_device: deviceId,
      scan_staff_id: staffId,
      scan_page_mode: scanMode,
    }

    if (scanMode === 'multi') {
      if (!scanSessionId) return Promise.reject(new Error('Missing scan session'))
      payload.scan_session_id = scanSessionId
      payload.scan_multi_action = multiAction || 'page'
    }

    this.setState({ scanning: true })
    this.armScanTimeout(scanMode === 'multi' && multiAction === 'finish' ? 90000 : 45000)

    return this.props.dispatch(patientUpdate(payload)).catch((err) => {
      clearTimeout(this.scanTimeout)
      this.setState({ scanning: false })
      throw err
    })
  }

  handleScanPage() {
    const { scanMode, selectedDeviceId, multiActive } = this.state
    if (!selectedDeviceId) {
      Alert.warning("Select an online scanner device.")
      return
    }

    if (scanMode === 'single') {
      this.dispatchScanCommand()
      return
    }

    // Multi: ensure session id before first page
    const startSession = !multiActive
    const sessionId = startSession ? this.newScanSessionId() : this.state.scanSessionId

    this.setState({
      multiActive: true,
      scanSessionId: sessionId,
    }, () => {
      this.dispatchScanCommand({ multiAction: 'page' })
    })
  }

  handleFinishMulti() {
    if (!this.state.multiActive || this.state.pageCount < 1) {
      Alert.warning("Scan at least one page before Finish.")
      return
    }
    this.dispatchScanCommand({ multiAction: 'finish' })
  }

  handleCancelMulti() {
    const { selectedDeviceId, scanSessionId, multiActive } = this.state
    if (!multiActive) {
      this.handleCloseScanModal()
      return
    }

    if (selectedDeviceId && scanSessionId) {
      this.dispatchScanCommand({ multiAction: 'cancel' }).finally(() => {
        clearTimeout(this.scanTimeout)
        this.closeScanModalNow()
      })
      return
    }

    this.closeScanModalNow()
  }

  handlePageScanned(data) {
    clearTimeout(this.scanTimeout)
    const count = Number(data.page_count) || (this.state.pageCount + 1)
    this.setState({
      scanning: false,
      pageCount: count,
      multiActive: true,
      scanSessionId: data.session_id || this.state.scanSessionId,
    })
  }

  handleScanComplete(data) {
    clearTimeout(this.scanTimeout)
    const failed = data && data.status === 'failed'
    if (failed) {
      this.setState({ scanning: false })
      return
    }
    this.closeScanModalNow()
  }

  handlePatientDocumentsLoad(filters) {
    filters.rpp = 100
    this.props.dispatch(patientDocumentsLoad(this.props.patientId, { ...filters, sort: 'patient_documents.created_at' }));
    filters.rpp = 10
    this.props.dispatch(filterChange({ filters: filters }));
  }

  handlePatientDocumentLoad(id) {
    this.props.dispatch(patientDocumentLoad(this.props.patientId, id, { include: ['document', 'tags'] }));
    this.setState({ activeTab: 'details' })
  }

  handlePatientDocumentEdit(id, formType) {
    if (id !== 'New') this.props.dispatch(patientDocumentLoad(this.props.patientId, id, { include: ['document', 'tags'] }));
    this.props.dispatch(patientDocumentEdit(id))
    if (formType === "upload") $('#uploadForm-modal').modal('show');
  }

  handlePatientDocumentEditCancel() {
    this.props.dispatch(patientDocumentEditCancel());
    $('#uploadForm-modal').modal('hide');
  }

  handlePatientDocumentDelete(id) {
    Alert.deleteConfirm("Are you sure? You want to delete this record.",
      (response) => {
        if (response)
          this.props.dispatch(patientDocumentDelete(this.props.patientId, id))
      })
  }

 async handlePatientDocumentSubmit(data) {
    const { userType } = this.props
    if (_.isEmpty(data)) {
      Alert.warning('No Attachment Selected.')
    }
    else {
      const id = data.id || '';
      data = userType === 'Patient' ? { ...data, document_attributes: { ...data.document_attributes, metadata: 'patient_uploaded' } } : data
      if (id === '') {
       await this.props.dispatch(patientDocumentCreate(this.props.patientId, data, { include: ['document', 'tags'] })).then(() => this.handleUploadFormClose())
        this.props.dispatch(patientLoad(this.props.patientId, { include: ['document', 'tags'] }))
      } else {
        new Promise(() => {
          this.props.dispatch(patientDocumentUpdate(this.props.patientId, data, { include: ['document', 'tags'] }))
            .then(() => {
              this.handleUploadFormClose()
              this.props.dispatch(patientDocumentLoad(this.props.patientId, id, { include: ['document', 'tags'] }))
            }
            )
        })
      }
    }
  }

  componentDidUpdate() {
    if (!this.props.patientDocumentEditing) {
      this.handleUploadFormClose()
    }
  }

  handleUploadFormClose() {
    $('#uploadForm-modal').modal('hide');
    this.props.dispatch(reset('uploadForm'))
  }

  componentWillUnmount() {
    clearTimeout(this.scanTimeout)
    this.props.dispatch(filterReset());
  }

  render() {
    const { patientDocuments, patientDocument, saving, match, filters, isWizard, patientId } = this.props
    const {
      scanning, scannerDevices, devicesLoaded, scanMode, selectedDeviceId,
      multiActive, pageCount, scanModalOpen
    } = this.state
    return (
      <div>
        <DocumentCable
          patientId={patientId}
          onPageScanned={this.handlePageScanned.bind(this)}
          onScanComplete={this.handleScanComplete.bind(this)}
        />
        <div className="row">
          <div className={`${isWizard ? 'col-12' : 'col-8'}`}>
            <div className="d-flex flex-row align-items-center justify-content-between">
              <h5>Documents</h5>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-primary mr-3"
                  disabled={scanning}
                  onClick={this.handleOpenScanModal.bind(this)}
                >
                  {scanning ? 'Scanning…' : 'Scan From Device'}
                </button>
                <button className="btn btn-primary" onClick={this.handlePatientDocumentEdit.bind(this, 'New', 'upload')}><i className='la la-plus mr-2 font-size-16'></i>Upload New</button>
              </div>
            </div>
            <div className="row mx-0 mt-7 patient-document">
              {patientDocuments.map(document => this.renderPatientDocument(document))}
            </div>
          </div>
          {!isWizard &&
            <div className="col-4">
              <div className="bg-white">
                <ul className="nav nav-tabs border-bottom border-bottom-2 border-light" id="myTab" role="tablist">
                  <li className="pl-5">
                    <a onClick={() => this.setState({ activeTab: "find" })} className={`py-5 pl-0 pr-7 tab-link ${this.state.activeTab === "find" && 'active'}`} id="find-document-tab" data-toggle="tab" href="#find-document" role="tab" aria-controls="find-document" aria-selected="true">
                      Find Document
                    </a>
                  </li>
                  <li className="pl-7">
                    <a onClick={() => this.setState({ activeTab: "details" })} className={`py-5 pl-0 pr-7 tab-link ${this.state.activeTab === "details" && 'active'}`} id="document-details-tab" data-toggle="tab" href="#document-details" role="tab" aria-controls="document-details" aria-selected="false">
                      Document Details
                    </a>
                  </li>
                </ul>
                <div className="tab-content overflow-auto" style={{ maxHeight: '550px' }}>
                  <div className={`tab-pane ${this.state.activeTab === "find" && 'active'}`} id="find-document" role="tabpanel" aria-labelledby="find-document-tab">
                    <div className="row mx-0">
                      <div className="col-12 px-6 py-7 border-bottom border-bottom-2 border-light">
                        <Search placeholder="Search Document" onChangeHook={(query) => this.handlePatientDocumentsLoad({ ...filters, search: query })} />
                      </div>
                      <div className="col-12">
                        <Tags handlePatientDocumentsLoad={this.handlePatientDocumentsLoad.bind(this)} match={match} />
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane ${this.state.activeTab === "details" && 'active'}`} id="document-details" role="tabpanel" aria-labelledby="document-details-tab">
                    {patientDocument.id && patientDocument.id ?
                      <DocumentForm onSubmit={this.handlePatientDocumentSubmit.bind(this)} handlePatientDocumentEdit={this.handlePatientDocumentEdit.bind(this, patientDocument.id)} saving={saving} />
                      :
                      <div className="text-center w-100 py-7">
                        <span className="text-muted">Select a file to view its details</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

        <ScanFromDeviceModal
          open={scanModalOpen}
          scanning={scanning}
          scanMode={scanMode}
          selectedDeviceId={selectedDeviceId}
          scannerDevices={scannerDevices}
          devicesLoaded={devicesLoaded}
          multiActive={multiActive}
          pageCount={pageCount}
          onClose={this.handleCloseScanModal.bind(this)}
          onChangeMode={(mode) => this.setState({ scanMode: mode, pageCount: mode === 'multi' ? 0 : this.state.pageCount })}
          onChangeDevice={(id) => this.setState({ selectedDeviceId: id })}
          onScanPage={this.handleScanPage.bind(this)}
          onFinish={this.handleFinishMulti.bind(this)}
          onCancel={this.handleCancelMulti.bind(this)}
          onRefreshDevices={this.loadScannerDevices.bind(this)}
        />

        <ModalFormWrapper
          formName="uploadForm"
          saving={saving}
          formTitle="Upload Document(s)"
          handleEditCancel={this.handlePatientDocumentEditCancel.bind(this)}>
          <UploadForm
            onSubmit={this.handlePatientDocumentSubmit.bind(this)}
          />
        </ModalFormWrapper>
      </div>
    );
  }

  handleDocumentView(document) {
    let isOverSizedDocument = document.document_attributes?.byte_size && document.document_attributes.byte_size > 10000000;
    let documentType = document.document_attributes?.content_type;
    if (isOverSizedDocument && documentType === "application/pdf") {
      return <span className="las la-eye-slash font-size-40 m-9 py-6 pl-5"></span>
    }
    else {
      if (documentType === "application/pdf") {
        return <embed src={document.document_attributes?.file?.url} className="pt-5 img-fluid" style={{ height: '12rem', objectFit: "fit" }} type="application/pdf"></embed>
      }
      else {
        return <img src={document.document_attributes?.file?.url} className="pt-5 img-fluid" style={{ height: '12rem', objectFit: "fit" }} />
      }
    }
  }

  renderPatientDocument(document) {
    const { tags } = this.props
    return (
      <div className={`col-3 bg-white mr-7 mb-7 ${this.state.activeDocument === document.id && 'border-primary border'}`} style={{ height: '16rem' }} onClick={() => { this.setState({ activeDocument: document.id }); this.handlePatientDocumentLoad(document.id) }}>
        {this.handleDocumentView(document)}
        <div className="py-5 d-flex align-items-center">
          <span className="text-truncate d-inline-block w-100">{document.document_attributes?.filename}</span>
          <div className="dropright d-inline-block float-right">
            <button type="button" className="btn p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <TooltipComponent title="More Options"><i className="la la-ellipsis-v" /></TooltipComponent>
            </button>
            <div className="dropdown-menu border-0 shadow-sm">
              <ul className="list-unstyled px-5 mb-0">
                <li className="py-2 pointer"><a className="text-dark" target="_blank" href={document.document_attributes?.file.url}>View</a></li>
                <li className="py-2 pointer" onClick={this.handlePatientDocumentLoad.bind(this, document.id)}>Details</li>
                <li className="py-2 pointer" onClick={this.handlePatientDocumentDelete.bind(this, document.id)}>Delete</li>
                <li className="py-2 pointer"><a download className="text-dark" href={document.document_attributes?.file.url}>Download</a></li>
                <li className="py-2 d-flex align-items-center justify-content-between tags-listing pointer">
                  Tag
                  <div className="dropright">
                    <a href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i className="la la-sm la-angle-right" />
                    </a>
                    <div className="dropdown-menu border-0 shadow">
                      <ul className="list-unstyled px-5 mb-0">
                        {tags.map(tag =>
                          <li className="py-2 d-flex flex-row align-items-center justify-content-between" onClick={this.handlePatientDocumentSubmit.bind(this, { id: document.id, tag_ids: toggleId(document.tag_ids, tag.id) })}>
                            <span>{tag.name}</span>
                            {_.includes(document.tag_ids, tag.id) && <i className="la la-sm la-check text-primary" />}
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { filter, patientDocument, tag, auth, patient } = state;
  return {
    patientId: ownProps.patientId || patient.patient?.id,
    staffId: auth.user?.id,
    userType: auth.user?.type,
    patientDocuments: patientDocument.patient_documents,
    tags: tag.tags,
    patientDocument: patientDocument.patient_document,
    patientDocumentEditing: patientDocument.editing,
    saving: patientDocument.saving,
    filters: filter.filters
  }
}

export default connect(mapStateToProps)(Document);
